import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaThumbResponse } from '../../../shared/api/responses/multimedia-thumb.response';
import { getMiniThumbUrl } from '../../../shared/api/helpers/get-mini-thumb-url';
import { getAlt } from '../../../shared/api/helpers/get-alt';
import { getMediumThumbUrl } from '../../../shared/api/helpers/get-medium-thumb-url';
import { getLargeThumbUrl } from '../../../shared/api/helpers/get-large-thumb-url';
import { MultimediaType } from '../../../shared/enums/multimedia-type';
import { MultimediaDimensionsResponse } from '../../../shared/api/responses/multimedia-dimensions.response';
import { AdminMultimediaContextOperationsResponse } from './admin-multimedia-context-operations.response';

@jsonObject
export class AdminMultimediaDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Number)
  public readonly size!: number;

  @jsonMember(String)
  public readonly mimeType!: string;

  @jsonMember(String)
  public readonly extension!: string;

  @jsonMember(String)
  public readonly title!: string;

  @jsonMember(String)
  public readonly downloadUrl!: string;

  @jsonMember(String)
  public readonly previewUrl!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(String)
  public readonly description?: Nillable<string>;

  @jsonMember(String)
  public readonly alternativeText?: Nillable<string>;

  @jsonMember(String)
  public readonly type!: MultimediaType;

  @jsonMember(MultimediaDimensionsResponse)
  public readonly dimensions?: Nillable<MultimediaDimensionsResponse>;

  @jsonArrayMember(MultimediaThumbResponse)
  public readonly thumbs!: MultimediaThumbResponse[];

  @jsonMember(AdminMultimediaContextOperationsResponse)
  public readonly contextOperations!: AdminMultimediaContextOperationsResponse;

  public get alt(): string {
    return getAlt(this.title, this.alternativeText);
  }

  public miniThumbUrl(): string {
    return getMiniThumbUrl(this.thumbs);
  }

  public mediumThumbUrl(): string {
    return getMediumThumbUrl(this.thumbs);
  }

  public largeThumbUrl(): string {
    return getLargeThumbUrl(this.thumbs);
  }
}
